<template>
    <div class="hts-routing">
        <hts-drawer
            ref="drawer"
            v-model="drawerVisible"
            :title="title"
            :describe="describe"
            :size="size"
            :rules="rules"
            :submit="submit"
            :reset="reset"
            :is-close="isClose"
            :close-hidden="closeHidden"
            :no-reset="noReset"
            :loading="loading"
            :disabled="disabled"
            @submit="onSubmit"
            @reset="onReset"
            @close="onClose"
            @handleSubmitClose="handleSubmitClose"
            @visible="handleVisible">
            <div>
                <slot />
            </div>
            <template #footer>
                <slot name="footer" />
            </template>
        </hts-drawer>
        <slot name="extends" />
    </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  },
  getData: {
    type: Function,
    default: () => {}
  },
  pageTabs: {
    type: Array,
    default: () => []
  },
  title: String,
  describe: String,
  isClose: {
    type: Boolean,
    default: false
  },
  right: {
    type: Boolean,
    default: true
  },
  disabled: {
    type: Boolean,
    default: false
  },
  size: [String, Number],
  submit: Function,
  reset: Function,
  rules: {
    type: Object,
    default: () => {}
  },
  closeHidden: Boolean,
  backRoute: Object,
  noReset: Boolean,
  loading: Boolean
})
const router = useRouter()
const route = useRoute()
const emits = defineEmits(['update:modelValue', 'loaded', 'submit', 'close', 'reset', 'refreshTables'])
const drawerVisible = ref(false)
const { getData, submit, backRoute, pageTabs } = toRefs(props)
onMounted(() => {
  drawerVisible.value = true
})
const handleVisible = (val: boolean) => {
  if (val) {
    nextTick(() => {
      emits('loaded')
    })
  }
}
const onClose = (e: any) => {
  emits('close', e)
  back()
}
const onReset = (e: any) => {
  emits('reset', e)
}
const onSubmit = (e: any) => {
  emits('submit', e)
}
const handleSubmitClose = (e?: any) => {
  emits('refreshTables')
  back()
}

const back = () => {
  setTimeout(() => {
    if (backRoute?.value) {
      router.push(backRoute.value)
    } else {
      useRouter().back()
    }
    setTimeout(() => {
      if (pageTabs.value && pageTabs.value.length) {
        route.meta.pageTabs = pageTabs.value || []
      }
    }, 100)
  }, 300)
}

defineExpose({ handleSubmitClose })
</script>
